import { render } from "./ReportSalesDispenser.vue?vue&type=template&id=2fe08a3b&scoped=true"
import script from "./ReportSalesDispenser.vue?vue&type=script&lang=js"
export * from "./ReportSalesDispenser.vue?vue&type=script&lang=js"

import "./ReportSalesDispenser.vue?vue&type=style&index=0&id=2fe08a3b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fe08a3b"]])

export default __exports__